import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useCreateAutomationModal } from '@hero/hooks';
import { PageLayout } from '@hero/layouts';
import { AutomationTable } from '@hero/organisms';

function AutomationList() {
  const { state } = useLocation();
  const { t } = useTranslation();
  const { showCreateAutomationModal } = useCreateAutomationModal();

  useEffect(() => {
    if (state?.isNewAutomation) {
      showCreateAutomationModal();
    }
  }, [state]);

  return (
    <PageLayout
      header={{
        title: t('automations'),
        createButton: {
          children: t('createNew'),
          onClick: showCreateAutomationModal
        }
      }}
    >
      <AutomationTable
        emptyState={{
          createNew: showCreateAutomationModal,
          feature: 'automation',
          icon: 'calendar'
        }}
      />
    </PageLayout>
  );
}

export { AutomationList };
